import {
  InMemoryHeader,
  InMemoryString
} from "pbas-vue-components";
import { translate2 } from '../trans2'

/*{
        {
          text: "Color",
          value: "Color",
          sortable: false,
          visible: true,
          displayFunc: "colorDisplayFunc",
          type: "string"
        }*/
const FlagsHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    searchable: false,
    version: 1
  }),
  new InMemoryHeader({
    type: new InMemoryString("Translations[]"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new InMemoryHeader({
    title: "globals.name",
    type: new InMemoryString("Name", {
      getString: (item) => translate2(item, "Name")
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.description",
    type: new InMemoryString("Description", {
      getString: (item) => translate2(item, "Description")
    }),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "globals.color",
    type: new InMemoryString("Color", {
      getHtml: (item, type) => {
        return (
          '<div class="v-avatar" style="height: 30px; min-width: 30px; width: 30px; background: ' +
          item.Color +
          '"></div>'
        );
      }
    }),
    sortable: false,
    visible: true,
    searchable: false
  })
];
export default FlagsHeaders;